module.exports = __webpack_public_path__ + "img/buttonMobile.04ce0aad.png";